/**
 * Why us section – key platform features/benefits in cards
 */
import { motion } from 'motion/react';
import { Workflow, ClipboardCheck, Shield, Building2 } from 'lucide-react';
import { content } from '@/landing/data/content';

const iconMap = {
  Workflow,
  ClipboardCheck,
  Shield,
  Building2,
};

export function WhyUs() {
  return (
    <section id="why-us" className="relative py-20 lg:py-28 bg-[var(--navy)] border-t border-[rgba(201,168,76,0.15)]">
      <div className="absolute inset-0 hero-grid-overlay opacity-40" />
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <h2 className="font-display text-3xl md:text-4xl font-semibold text-[var(--gold)] mb-3">
            Why INSOLIP?
          </h2>
          <p className="text-lg text-[var(--text-muted)] max-w-2xl mx-auto font-light">
            Key features that make innovation management simple and transparent
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 items-stretch">
          {content.whyUs.map((item, index) => {
            const Icon = iconMap[item.icon as keyof typeof iconMap];
            return (
              <motion.article
                key={item.title}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                whileHover={{ y: -4 }}
                className="insolip-card-gradient rounded-2xl border border-[rgba(255,255,255,0.08)] p-6 hover:border-[rgba(201,168,76,0.3)] transition-all duration-300 h-full flex flex-col"
              >
                <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-white/10 border border-[rgba(201,168,76,0.3)] text-[var(--gold)] mb-4 flex-shrink-0">
                  {Icon && <Icon className="w-6 h-6" />}
                </div>
                <h3 className="font-display text-lg font-semibold text-white mb-2">
                  {item.title}
                </h3>
                <p className="text-white/85 text-sm leading-relaxed font-light flex-1">
                  {item.description}
                </p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
